<template>
  <div id="app">
    <router-view></router-view>
    <assistant-drawer />
    <global-watermark />
  </div>
</template>

<script>
import '@/assets/styles/global.css'
import AssistantDrawer from './components/AssistantDrawer.vue'
import GlobalWatermark from './components/GlobalWatermark.vue'

export default {
  name: 'app',
  components: { AssistantDrawer, GlobalWatermark }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  /* box-sizing: border-box; */
}

html, body {
  height: 100%;
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  height: 100%;
}

/* 路由过渡动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>
